import { render } from "./EditUserRoles.vue?vue&type=template&id=d36e78ee"
import script from "./EditUserRoles.vue?vue&type=script&lang=js"
export * from "./EditUserRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__